// useAnalytics.ts
import { useQuery } from "@tanstack/react-query";
import { getTaxProAnalytics } from "../api/analytics";
import { useStatusStore } from "../stores/useStatusStore";

interface AnalyticsData {
  clientStatus: Record<string, number>;
  organizerStatus: Record<string, number>;
  assignees: Array<{
    userId: string | null;
    name: string;
    count: number;
  }>;
  totalClients: number;
}

export const useTaxProAnalytics = () => {
  const { selectedTaxYear } = useStatusStore();

  const queryKey = ["analytics", { taxYear: selectedTaxYear }];

  const {
    data,
    isLoading: isLoadingAnalytics,
    isError: isErrorAnalytics,
    error: errorAnalytics,
  } = useQuery<AnalyticsData, Error>({
    queryKey,
    queryFn: async () => {
      const response = await getTaxProAnalytics({
        tax_year: selectedTaxYear,
      });
      return response;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes - data is fresh for this duration
    gcTime: 1000 * 60 * 10, // 10 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: false, // Disabled: 5-minute cache is sufficient
    refetchOnReconnect: true,
  });

  return {
    statuses: data?.clientStatus,
    organizerStatuses: data?.organizerStatus,
    assignees: data?.assignees,
    totalClients: data?.totalClients,
    isLoadingAnalytics,
    isErrorAnalytics,
    errorAnalytics,
  };
};
